var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"8","sm":"10"}},[_c('span',{staticClass:"font-weight-light",staticStyle:{"font-size":"16pt"}},[_vm._v(_vm._s(_vm.$t('label.payments')))])])],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('payments-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }